import React, { useEffect } from 'react';
import '../Css_files/ImageModal.css';
import Icon1 from './AppIcon';
import Image from './AppImage';

const ImageModal = ({ achievement, isOpen, onClose }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose]);

  if (!isOpen || !achievement) return null;

  return (
    <div className="image-modal">
      {/* Backdrop */}
      <div 
        className="modal-backdrop"
        onClick={onClose}
      />
      
      {/* Modal Content */}
      <div className="modal-content">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="modal-close-button"
          aria-label="Close modal"
        >
          <Icon1 name="X" size={20} />
        </button>

        {/* Image */}
        <div className="modal-image-container">
          <Image
            src={achievement.image}
            alt={achievement.title}
            className="modal-image"
          />
          <div className="modal-image-overlay">
            <span className="modal-category-badge">
              {achievement.category}
            </span>
          </div>
        </div>

        {/* Content */}
        <div className="modal-body">
          <div className="modal-meta">
            <span className="modal-date">{achievement.date}</span>
          </div>
          <h2 className="modal-title">
            {achievement.title}
          </h2>
          <p className="modal-description">
            {achievement.description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ImageModal;